<template>
  <div>
    <div class="signup my-1 md:my-0">
      <!-- <input type="email" v-model="payload.email" placeholder="Your email" /> -->
      <!-- <button class="button" @click="submit">Sign up</button> -->
      <button class="button" @click="redirect('https://mailchi.mp/merc.org.nz/connect-with-seaweek')">Sign up</button>
    </div>

    <div class="email">
      <p v-if="payload.error" class="__error">{{ payload.error }}</p>
      <p v-if="payload.success" class="__success">{{ payload.success }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payload: {
        email: "",
        error: "",
        success: "",
      },
    };
  },
  methods: {
    submit() {
      if (this.payload.email) {
        window.axios
          .post("/api/subscribers", this.payload)
          .then((res) => {
            this.$store.state.isLoading = false;
            if (res.data.success) {
              this.payload.email = null;
              this.payload.success = "Thanks, you have been subscribed!";
              this.payload.error = "";
            } else {
              this.payload.error =
                "Sorry something went wrong, try again later.";
            }
          })
          .catch((error) => {
            this.payload.error = error.response.data.message;
          });
      } else {
        this.payload.error = "Invalid email";
        this.isSubscribed = false;
      }
    },
    redirect(url){
      window.open(url, '_blank');
    }
  },
};
</script>
<style scoped>
.__error {
  color: #f74444c7 !important;
  font-size: 14px !important;
  margin-top: 10px !important;
  text-align: left !important;
}
.__success {
  color: #1edb18c7 !important;
  font-size: 14px !important;
  margin-top: 10px !important;
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/utils/Newsletter.vue